import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'client/store/configureStore';
import { HierarchyLevelType } from 'common/interfaces/hierarchy-entities';
import { groupBy } from 'es-toolkit/compat';
import { HIERARCHY_ENTITIES_INFO } from 'common/enums/entity-enums';

export const hierarchySelector = ({
  entities: {
    archive, country, field, site, well, wellbore, design,
  },
}: RootState) => {
  return {
    archive, country, field, site, well, wellbore, design,
  };
};

export const getHierarchyDataState = createSelector(
  hierarchySelector,
  ({
    archive, country, field, site, well, wellbore, design,
  }) => {
    return {
      archive: archive.archives,
      country: country.items,
      field: field.items,
      site: site.items,
      well: well.items,
      wellbore: wellbore.items,
      design: design.items,
    };
  },
);

export const getHierarchyDataStateGrouped = createSelector(
  hierarchySelector,
  ({
    site, well, field
  }) => {
    return {
      sites: groupBy(site.items, HIERARCHY_ENTITIES_INFO[HierarchyLevelType.Site]),
      wells: groupBy(well.items, HIERARCHY_ENTITIES_INFO[HierarchyLevelType.Well]),
      fields: groupBy(field.items, HIERARCHY_ENTITIES_INFO[HierarchyLevelType.Field]),
    };
  },
);
